import React, { useState, useEffect } from "react";
import { Shape, Text } from "react-konva";
import { Html } from "react-konva-utils";
import { HeightLinesForFreeForm } from "Components/tool-new/tool-utils/heightUtils";
import { calculateNextPoint } from "Components/tool/utils";
import { freeHeightUpperPadding, freeHeightLowerPadding } from "../../preview/preview-constants";
import { checkNextLineFreeform } from "Components/tool-new/tool-utils/heightUtils";
//This component is to draw lines and input for heights.
const HeightLinesLabels = (props: any) => {
  const {
    path,
    freeLengths,
    stageRef,
    canvasWidth,
    canvasHeight,
    rebarHeight,
    showHeight,
    stageScale,
    handleHeightChange,
    isDraggingCanvas,
    freeLineAngles,
  } = props;

  const stage = stageRef.current.getStage();
  const [allHeightLines, setAllHeightLines] = useState([]);
  const [inputPoints, setInputPoints] = useState([]);

  const isBoxInsidetheSketch = (x, y) => {
    if (x < 0 || y < 0) {
      return true;
    } else if (x > 795) {
      return true;
    } else if (y + 20 > 520) {
      return true;
    }
  };

  const isLabelInsidetheSketch = (x, y, textX, textY) => {
    if (textX < 0 || textY < 0 || x < 0 || y < 0) {
      return true;
    } else if (textX > 795 || x > 795) {
      return true;
    } else if (textY > 520 || y + 20 > 520) {
      return true;
    }
  };

  useEffect(() => {
    if (
      path.lines &&
      canvasWidth > 200 &&
      canvasHeight > 200 &&
      path.lines.length > 0
    ) {
      const _midpoints: any[] = [];
      path.lines.forEach((side: any, index: number) => {
        const previousPoint = { x: side.x1, y: side.y1 };
        const currentPoint = { x: side.x2, y: side.y2 };
        const length = freeLengths[index];
        // if the angle is outter angle
        const outterInput =
          side.outer ||
          (index >= 1 &&
            !path.lines[index - 1].change_previous_point &&
            path.lines[index - 1].outer);
        // Calculate Points for inputs on the canvas
        // find midpoint of line - 25 as intermediate point
        const invertedLine = previousPoint.x > currentPoint.x; // if difference is negactive b/w Xs
        const inputSizeMid = 25;
        const intermedia = calculateNextPoint(
          previousPoint,
          side.line_angle,
          invertedLine ? length / 2 + inputSizeMid : length / 2 - inputSizeMid
        );
        // revert the point at 90 degrees to get oposite point
        const pointToInput = calculateNextPoint(
          intermedia,
          outterInput ? side.line_angle - 90 : side.line_angle + 90,
          outterInput || invertedLine ? 27 : 4
        );
        let pointToText = { x: 0, y: 0 };
        if (invertedLine) {
          pointToText = pointToText = calculateNextPoint(
            pointToInput as any,
            outterInput ? side.line_angle - 150 : side.line_angle + 150,
            22
          );
        } else {
          pointToText = calculateNextPoint(
            pointToInput as any,
            outterInput
              ? (side.line_angle - 32) % 360
              : (side.line_angle + 51) % 360,
            outterInput ? 23 : 32
          );
        }
        _midpoints.push({
          input: pointToInput,
          text: pointToText,
          invertedLine,
        });
      });
      setInputPoints(_midpoints);
      return () => {
        setInputPoints([]);
      };
    }
  }, [path, canvasWidth, canvasHeight]);

  useEffect(() => {
    if (
      path.lines &&
      path.lines.length > 0 &&
      canvasWidth > 200 &&
      canvasHeight > 200
    ) {
      let allHeightLine = [];

      path.lines.forEach((side: any, index: number) => {
        const length = freeLengths[index];
        let previousPoint = { x: side.x1, y: side.y1 };
        const currentPoint = { x: side.x2, y: side.y2 };

        if (rebarHeight.length > 0 && inputPoints.length > 0) {
          const sideHeight = rebarHeight.find((obj) => obj.id === side.id);
          if (sideHeight) {
            const lineToDraw = HeightLinesForFreeForm(
              side,
              path.lines,
              currentPoint,
              previousPoint,
              index,
              inputPoints
            );
            allHeightLine.push({ ...lineToDraw, id: path.lines[index].id });
            setAllHeightLines(allHeightLine);
          }
        }
      });
    }
  }, [path, canvasHeight, canvasWidth, rebarHeight, rebarHeight, inputPoints]);

  return (
    <>
      {showHeight && !isDraggingCanvas && (
        <>
          <Shape
            sceneFunc={(context, shape) => {
              context.strokeStyle = "#878C97";
              context.lineWidth = 0.3;
              context.beginPath();
              if (
                allHeightLines.length > 0 &&
                rebarHeight.length > 0 &&
                showHeight
              ) {
                allHeightLines.forEach((side, index) => {
                  let paddingUp = true;
                  let paddingDown = true;

                  let relativePositionNext = -1;
                  let relativePositionPrevious = -1;

                  const angleIndex = freeLineAngles.findIndex((item) => item.id === side.id);

                  if(angleIndex > 0){
                    relativePositionPrevious = checkNextLineFreeform(freeLineAngles[angleIndex].angle, freeLineAngles[angleIndex - 1].angle, true);
                  }
                  if (angleIndex < freeLineAngles.length -1  && freeLineAngles.length > 1){
                    relativePositionNext = checkNextLineFreeform(freeLineAngles[angleIndex].angle, freeLineAngles[angleIndex + 1].angle)
                  }

                  paddingDown = !(relativePositionPrevious === 1 || relativePositionNext === 1);
                  paddingUp = !(relativePositionPrevious === 0 || relativePositionNext === 0);

                                    
                  //horizontalLine
                  context.moveTo(side?.firstLine?.x1, side.firstLine?.y1 + (side.firstLine.y1 > side.secondLine.y1 ? (paddingDown ? freeHeightLowerPadding : 0) : (paddingUp ? freeHeightUpperPadding : 0)));
                  context.lineTo(side?.firstLine?.x2, side.firstLine?.y2 + (side.firstLine.y1 > side.secondLine.y1 ? (paddingDown ? freeHeightLowerPadding : 0) : (paddingUp ? freeHeightUpperPadding : 0)));

                  //verticalLine
                  context.moveTo(side?.midLine?.x1, side.midLine?.y1);
                  context.lineTo(side?.midLine?.x2, side.midLine?.y2);

                  //horizontalLine
                  context.moveTo(
                    side?.secondLine?.x1,
                    side?.secondLine?.y1 + (side.secondLine.y1 > side.firstLine.y1 ? (paddingDown ? freeHeightLowerPadding : 0) : (paddingUp ? freeHeightUpperPadding : 0))
                  );
                  context.lineTo(
                    side?.secondLine?.x2,
                    side?.secondLine?.y2 + (side.secondLine.y1 > side.firstLine.y1 ? (paddingDown ? freeHeightLowerPadding : 0) : (paddingUp ? freeHeightUpperPadding : 0))
                  );

                  //top arrow left line
                  context.moveTo(side?.topArrow?.x, side?.topArrow?.y);
                  context.lineTo(
                    side?.topArrow?.x - 1.5,
                    side?.topArrow?.y + 1.5
                  );

                  //top arrow right line
                  context.moveTo(side?.topArrow?.x, side?.topArrow?.y);
                  context.lineTo(
                    side?.topArrow?.x + 1.5,
                    side?.topArrow?.y + 1.5
                  );

                  //bottom arrow left line
                  context.moveTo(side?.bottomArrow?.x, side?.bottomArrow?.y);
                  context.lineTo(
                    side?.bottomArrow?.x - 1.5,
                    side?.bottomArrow?.y - 1.5
                  );

                  //bottom arrow right line
                  context.moveTo(side?.bottomArrow?.x, side?.bottomArrow?.y);
                  context.lineTo(
                    side?.bottomArrow?.x + 1.5,
                    side?.bottomArrow?.y - 1.5
                  );
                });
              }
              context.closePath();
              context.stroke();
            }}
            stroke="red"
            strokeWidth={0.1 * stageScale}
          />

          {!props.mobile && showHeight &&
            rebarHeight.length > 0 &&
            allHeightLines.map((side, index) => (
              <React.Fragment key={"rebar_height" + index}>
                <Html
                  divProps={{
                    style: {
                      display: isBoxInsidetheSketch(
                        side.inputBox.x * stage.scaleX() + stage.x() - 25,
                        side.inputBox.y * stage.scaleY() + stage.y() - 25
                      )
                        ? "none"
                        : "block",
                      position: "absolute",
                      top: `${side.inputBox.y * stage.scaleY() + stage.y() - 25}px`,
                      left: `${side.inputBox.x * stage.scaleX() + stage.x()}px`,
                      transform: `rotate(${
                        side.inputBox.invertedLine
                          ? 0
                          : 0
                      }deg)`,
                    },}}
                >

                    <p style={{ fontSize: "16px", paddingBottom: "0px", paddingLeft: '15px' }}>
                      {"h" + parseInt(index + 1)}
                    </p>

                  <input
                    onFocus={(e) => e.target.select()}
                    className={"inputField "}
                    type="number"
                    style={{ width: "50px" }}
                    value={rebarHeight[index]?.height || ""}
                    onChange={(e) => {
                      handleHeightChange(
                        parseInt(e.target.value),
                        index,
                        rebarHeight[index].id,
                        rebarHeight[index].angle
                      );
                    }}
                  />
                </Html>
              </React.Fragment>
            ))}
        </>
      )}
    </>
  );
};

export default HeightLinesLabels;
